import { render, staticRenderFns } from "./infinity-scrolling.vue?vue&type=template&id=402165c5&"
import script from "./infinity-scrolling.vue?vue&type=script&lang=js&"
export * from "./infinity-scrolling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports